// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════
   Batch Selection Modal
═══════════════════════════════════════════════════ */

/* Overlay / centering shell */
.bp-root {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1300;
  outline: none;
}
.bp-root--mobile {
  align-items: flex-end;
  padding: 0;
}

/* Modal card */
.bp-modal {
  background: #fff;
  border-radius: 20px;
  width: 100%;
  max-width: 520px;
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18), 0 4px 16px rgba(0, 0, 0, 0.08);
  outline: none;
}
.bp-root--mobile .bp-modal {
  max-width: 100%;
  border-radius: 20px 20px 0 0;
  max-height: 90vh;
}

/* ── Header ── */
.bp-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 20px 16px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.bp-header-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  color: #2a71ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bp-header-text {
  flex: 1;
  min-width: 0;
}

.bp-title {
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 2px;
  letter-spacing: -0.02em;
}

.bp-subtitle {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin: 0 0 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bp-gtin {
  font-size: 11.5px;
  color: #94a3b8;
  margin: 0;
}

.bp-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
}
.bp-close-btn:hover { background: #e2e8f0; color: #0f172a; }

/* ── Meta bar ── */
.bp-meta-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  flex-shrink: 0;
}

.bp-count-pill {
  font-size: 11.5px;
  font-weight: 700;
  color: #2a71ff;
  background: #eff6ff;
  border-radius: 999px;
  padding: 3px 10px;
}

.bp-keyboard-hint {
  font-size: 10.5px;
  color: #cbd5e1;
}

/* ── Batch list ── */
.bp-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* ── Batch card ── */
.bp-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 14px 14px 14px 12px;
  border-radius: 14px;
  border: 1.5px solid #e2e8f0;
  background: #f8fafc;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  position: relative;
}
.bp-card:hover {
  border-color: #93c5fd;
  background: #f0f7ff;
}
.bp-card--selected {
  border-color: #2a71ff;
  background: #eff6ff;
  box-shadow: 0 0 0 3px rgba(42, 113, 255, 0.12);
}
.bp-card--expired {
  opacity: 0.65;
  background: #fff5f5;
  border-color: #fecaca;
}
.bp-card--expired:hover { border-color: #fca5a5; }

/* ── Custom radio ── */
.bp-radio {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s;
}
.bp-radio--on {
  border-color: #2a71ff;
  background: #2a71ff;
}
.bp-radio-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
}

/* ── Card body ── */
.bp-card-body { flex: 1; min-width: 0; }

.bp-prices {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.bp-sp {
  font-size: 18px;
  font-weight: 800;
  color: #1e40af;
  letter-spacing: -0.02em;
}

.bp-mrp {
  font-size: 18px;
  font-weight: 500;
  /* color: #94a3b8; */
  text-decoration: line-through;
  font-weight: 600;
}

.bp-offer-tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 10.5px;
  font-weight: 700;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 999px;
  padding: 2px 8px;
  margin-left: auto;
}

/* ── Info chips ── */
.bp-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 6px;
}

.bp-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 3px 9px;
}
.bp-chip--batch {
  font-size: 22px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
}
.bp-chip--expired {
  color: #b91c1c;
  background: #fef2f2;
  border-color: #fecaca;
}

/* ── Offer names ── */
.bp-offer-names {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 4px;
}
.bp-offer-name-chip {
  font-size: 10.5px;
  font-weight: 600;
  color: #b45309;
  background: #fffbeb;
  border-radius: 6px;
  padding: 2px 8px;
  border: 1px solid #fde68a;
}

/* ── Expired pill ── */
.bp-expired-pill {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.05em;
  color: #fff;
  background: #ef4444;
  border-radius: 999px;
  padding: 2px 8px;
}

/* ── Footer ── */
.bp-footer {
  display: flex;
  gap: 10px;
  padding: 14px 20px 20px;
  border-top: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.bp-btn {
  flex: 1;
  height: 44px;
  border-radius: 12px;
  border: none;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background 0.15s, opacity 0.15s;
}

.bp-btn--cancel {
  background: #f1f5f9;
  color: #475569;
}
.bp-btn--cancel:hover { background: #e2e8f0; }

.bp-btn--add {
  background: #2a71ff;
  color: #fff;
  box-shadow: 0 4px 14px rgba(42, 113, 255, 0.3);
}
.bp-btn--add:hover:not(:disabled) { background: #1f63ea; }
.bp-btn--add:disabled { opacity: 0.45; cursor: not-allowed; box-shadow: none; }
.bp-btn--add.bp-btn--loading:disabled { opacity: 0.85; cursor: progress; }
.bp-btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: bp-spin 0.7s linear infinite;
}
@keyframes bp-spin { to { transform: rotate(360deg); } }

/* ═══════════════════════════════════════════════════
   Dark mode
═══════════════════════════════════════════════════ */
.dark .bp-modal { background: #111827; }

.dark .bp-header { border-bottom-color: #1e293b; }
.dark .bp-header-icon { background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%); color: #93c5fd; }
.dark .bp-title { color: #f1f5f9; }
.dark .bp-subtitle { color: #cbd5e1; }
.dark .bp-gtin { color: #475569; }
.dark .bp-close-btn { background: #1e293b; color: #64748b; }
.dark .bp-close-btn:hover { background: #334155; color: #e2e8f0; }

.dark .bp-count-pill { background: #1e293b; color: #60a5fa; }
.dark .bp-keyboard-hint { color: #334155; }

.dark .bp-card { background: #1e293b; border-color: #334155; }
.dark .bp-card:hover { background: #1e3a5f; border-color: #3b82f6; }
.dark .bp-card--selected { background: #1e3a5f; border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.2); }
.dark .bp-card--expired { background: #1f1010; border-color: #7f1d1d; }

.dark .bp-radio { border-color: #475569; }
.dark .bp-sp { color: #93c5fd; }
.dark .bp-mrp { color: #475569; }

.dark .bp-chip { background: #0f172a; border-color: #334155; color: #94a3b8; }
.dark .bp-chip--expired { color: #f87171; background: rgba(239,68,68,0.1); border-color: #7f1d1d; }
.dark .bp-offer-tag { background: #1c1608; border-color: #78350f; color: #fbbf24; }
.dark .bp-offer-name-chip { background: #1c1608; border-color: #78350f; color: #fbbf24; }

.dark .bp-footer { border-top-color: #1e293b; }
.dark .bp-btn--cancel { background: #1e293b; color: #94a3b8; }
.dark .bp-btn--cancel:hover { background: #334155; }
.dark .bp-btn--add { background: #1d4ed8; box-shadow: 0 4px 14px rgba(29,78,216,0.4); }
.dark .bp-btn--add:hover:not(:disabled) { background: #1e40af; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/batch-popup/index.css"],"names":[],"mappings":"AAAA;;qDAEqD;;AAErD,8BAA8B;AAC9B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2EAA2E;EAC3E,aAAa;AACf;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;AACA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;;AAE3D,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,OAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA,0BAA0B,qBAAqB,EAAE;;AAEjD,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB,gBAAgB,OAAO,EAAE,YAAY,EAAE;;AAEvC;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;AACA,oCAAoC,mBAAmB,EAAE;AACzD,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC9E,wCAAwC,aAAa,EAAE,gBAAgB,EAAE;AACzE;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD;;qDAEqD;AACrD,kBAAkB,mBAAmB,EAAE;;AAEvC,mBAAmB,4BAA4B,EAAE;AACjD,wBAAwB,6DAA6D,EAAE,cAAc,EAAE;AACvG,kBAAkB,cAAc,EAAE;AAClC,qBAAqB,cAAc,EAAE;AACrC,iBAAiB,cAAc,EAAE;AACjC,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;;AAEjE,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,0BAA0B,cAAc,EAAE;;AAE1C,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE;AAC7D,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;AACnE,2BAA2B,mBAAmB,EAAE,qBAAqB,EAAE,0CAA0C,EAAE;AACnH,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE;;AAEtE,kBAAkB,qBAAqB,EAAE;AACzC,eAAe,cAAc,EAAE;AAC/B,gBAAgB,cAAc,EAAE;;AAEhC,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC7E,0BAA0B,cAAc,EAAE,+BAA+B,EAAE,qBAAqB,EAAE;AAClG,sBAAsB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAClF,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAExF,mBAAmB,yBAAyB,EAAE;AAC9C,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,8BAA8B,mBAAmB,EAAE;AACnD,qBAAqB,mBAAmB,EAAE,0CAA0C,EAAE;AACtF,0CAA0C,mBAAmB,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════════\n   Batch Selection Modal\n═══════════════════════════════════════════════════ */\n\n/* Overlay / centering shell */\n.bp-root {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 1300;\n  outline: none;\n}\n.bp-root--mobile {\n  align-items: flex-end;\n  padding: 0;\n}\n\n/* Modal card */\n.bp-modal {\n  background: #fff;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 520px;\n  max-height: 86vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18), 0 4px 16px rgba(0, 0, 0, 0.08);\n  outline: none;\n}\n.bp-root--mobile .bp-modal {\n  max-width: 100%;\n  border-radius: 20px 20px 0 0;\n  max-height: 90vh;\n}\n\n/* ── Header ── */\n.bp-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 20px 20px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.bp-header-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  color: #2a71ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.bp-header-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.bp-title {\n  font-size: 16px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 2px;\n  letter-spacing: -0.02em;\n}\n\n.bp-subtitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n  margin: 0 0 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.bp-gtin {\n  font-size: 11.5px;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.bp-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: #f1f5f9;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s, color 0.15s;\n}\n.bp-close-btn:hover { background: #e2e8f0; color: #0f172a; }\n\n/* ── Meta bar ── */\n.bp-meta-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  flex-shrink: 0;\n}\n\n.bp-count-pill {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #2a71ff;\n  background: #eff6ff;\n  border-radius: 999px;\n  padding: 3px 10px;\n}\n\n.bp-keyboard-hint {\n  font-size: 10.5px;\n  color: #cbd5e1;\n}\n\n/* ── Batch list ── */\n.bp-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* ── Batch card ── */\n.bp-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n  padding: 14px 14px 14px 12px;\n  border-radius: 14px;\n  border: 1.5px solid #e2e8f0;\n  background: #f8fafc;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;\n  position: relative;\n}\n.bp-card:hover {\n  border-color: #93c5fd;\n  background: #f0f7ff;\n}\n.bp-card--selected {\n  border-color: #2a71ff;\n  background: #eff6ff;\n  box-shadow: 0 0 0 3px rgba(42, 113, 255, 0.12);\n}\n.bp-card--expired {\n  opacity: 0.65;\n  background: #fff5f5;\n  border-color: #fecaca;\n}\n.bp-card--expired:hover { border-color: #fca5a5; }\n\n/* ── Custom radio ── */\n.bp-radio {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid #cbd5e1;\n  flex-shrink: 0;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: border-color 0.15s;\n}\n.bp-radio--on {\n  border-color: #2a71ff;\n  background: #2a71ff;\n}\n.bp-radio-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #fff;\n}\n\n/* ── Card body ── */\n.bp-card-body { flex: 1; min-width: 0; }\n\n.bp-prices {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.bp-sp {\n  font-size: 18px;\n  font-weight: 800;\n  color: #1e40af;\n  letter-spacing: -0.02em;\n}\n\n.bp-mrp {\n  font-size: 18px;\n  font-weight: 500;\n  /* color: #94a3b8; */\n  text-decoration: line-through;\n  font-weight: 600;\n}\n\n.bp-offer-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #b45309;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 999px;\n  padding: 2px 8px;\n  margin-left: auto;\n}\n\n/* ── Info chips ── */\n.bp-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n\n.bp-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #475569;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 999px;\n  padding: 3px 9px;\n}\n.bp-chip--batch {\n  font-size: 22px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.01em;\n}\n.bp-chip--expired {\n  color: #b91c1c;\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n\n/* ── Offer names ── */\n.bp-offer-names {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-top: 4px;\n}\n.bp-offer-name-chip {\n  font-size: 10.5px;\n  font-weight: 600;\n  color: #b45309;\n  background: #fffbeb;\n  border-radius: 6px;\n  padding: 2px 8px;\n  border: 1px solid #fde68a;\n}\n\n/* ── Expired pill ── */\n.bp-expired-pill {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 9.5px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  color: #fff;\n  background: #ef4444;\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n/* ── Footer ── */\n.bp-footer {\n  display: flex;\n  gap: 10px;\n  padding: 14px 20px 20px;\n  border-top: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.bp-btn {\n  flex: 1;\n  height: 44px;\n  border-radius: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: background 0.15s, opacity 0.15s;\n}\n\n.bp-btn--cancel {\n  background: #f1f5f9;\n  color: #475569;\n}\n.bp-btn--cancel:hover { background: #e2e8f0; }\n\n.bp-btn--add {\n  background: #2a71ff;\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(42, 113, 255, 0.3);\n}\n.bp-btn--add:hover:not(:disabled) { background: #1f63ea; }\n.bp-btn--add:disabled { opacity: 0.45; cursor: not-allowed; box-shadow: none; }\n.bp-btn--add.bp-btn--loading:disabled { opacity: 0.85; cursor: progress; }\n.bp-btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: bp-spin 0.7s linear infinite;\n}\n@keyframes bp-spin { to { transform: rotate(360deg); } }\n\n/* ═══════════════════════════════════════════════════\n   Dark mode\n═══════════════════════════════════════════════════ */\n.dark .bp-modal { background: #111827; }\n\n.dark .bp-header { border-bottom-color: #1e293b; }\n.dark .bp-header-icon { background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%); color: #93c5fd; }\n.dark .bp-title { color: #f1f5f9; }\n.dark .bp-subtitle { color: #cbd5e1; }\n.dark .bp-gtin { color: #475569; }\n.dark .bp-close-btn { background: #1e293b; color: #64748b; }\n.dark .bp-close-btn:hover { background: #334155; color: #e2e8f0; }\n\n.dark .bp-count-pill { background: #1e293b; color: #60a5fa; }\n.dark .bp-keyboard-hint { color: #334155; }\n\n.dark .bp-card { background: #1e293b; border-color: #334155; }\n.dark .bp-card:hover { background: #1e3a5f; border-color: #3b82f6; }\n.dark .bp-card--selected { background: #1e3a5f; border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.2); }\n.dark .bp-card--expired { background: #1f1010; border-color: #7f1d1d; }\n\n.dark .bp-radio { border-color: #475569; }\n.dark .bp-sp { color: #93c5fd; }\n.dark .bp-mrp { color: #475569; }\n\n.dark .bp-chip { background: #0f172a; border-color: #334155; color: #94a3b8; }\n.dark .bp-chip--expired { color: #f87171; background: rgba(239,68,68,0.1); border-color: #7f1d1d; }\n.dark .bp-offer-tag { background: #1c1608; border-color: #78350f; color: #fbbf24; }\n.dark .bp-offer-name-chip { background: #1c1608; border-color: #78350f; color: #fbbf24; }\n\n.dark .bp-footer { border-top-color: #1e293b; }\n.dark .bp-btn--cancel { background: #1e293b; color: #94a3b8; }\n.dark .bp-btn--cancel:hover { background: #334155; }\n.dark .bp-btn--add { background: #1d4ed8; box-shadow: 0 4px 14px rgba(29,78,216,0.4); }\n.dark .bp-btn--add:hover:not(:disabled) { background: #1e40af; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
